import React from "react";

import "./loadingCard.scss";

export default function LoadingCard({ animationTime, height, quantity }) {
  const loadingReturn = new Array(quantity || 1).fill("-");

  return (
    <>
      {loadingReturn.map((el, index) => {
        return (
          <div key={index} className="loadingContainer">
            <div
              className="loadingContainer__loader"
              style={{ "--animationTime": animationTime || "2s", height }}
            ></div>
          </div>
        );
      })}
    </>
  );
}
